module.exports = __webpack_public_path__ + "media/images/common/logo-8077468bbada8ac3cc9a264f2b5c21cd.gif";